var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _path3, _path4, _path5, _rect6, _path6, _path7, _rect7, _path8, _path9, _path0, _rect8, _path1, _rect9, _path10, _path11, _rect0, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse3Floor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 53 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85449 52.3494H48.8083V67.9064H44.2567V56.2216H33.9306V67.9064H4.85449V52.3494Z",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.1332,
    height: 3.87228,
    transform: "matrix(1 0 0 -1 1.79785 71.7787)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.54076,
    height: 3.87228,
    transform: "matrix(1 0 0 -1 44.2568 71.7787)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 3.87228,
    transform: "matrix(1 0 0 -1 1.79785 52.3494)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 3.87228,
    transform: "matrix(1 0 0 -1 1.79785 32.92)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6934 71.7787H44.529",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 13.1114,
    height: 7.09918,
    transform: "matrix(1 0 0 -1 10.4004 63.3547)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9561 63.3547V56.2556",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25195 63.3547L25.6602 63.3547",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85449 32.92H48.8083V48.4771H4.85449V32.92Z",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 13.1114,
    height: 7.09918,
    transform: "matrix(1 0 0 -1 10.3994 43.9257)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9551 43.9257V36.8265",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25098 43.9257L25.6593 43.9257",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 13.1114,
    height: 7.09918,
    transform: "matrix(1 0 0 -1 30.084 43.9257)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6396 43.9257V36.8265",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9355 43.9257L45.3438 43.9257",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85449 13.4906H48.8083V29.0477H4.85449V13.4906Z",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 9.03533,
    height: 9.1712,
    transform: "matrix(1 0 0 -1 33.8633 10.2297)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8631 5.27049H7.23263L1.79785 13.4906H51.7979L46.3631 5.27049H42.8984",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 13.1114,
    height: 7.09918,
    transform: "matrix(1 0 0 -1 10.4004 24.4961)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9561 24.4961V17.3969",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25195 24.4961L25.6602 24.4961",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 13.1114,
    height: 7.09918,
    transform: "matrix(1 0 0 -1 30.084 24.4961)",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6396 24.4961V17.3969",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9355 24.4961L45.3438 24.4961",
    stroke: "#808080",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse3Floor);
export default __webpack_public_path__ + "static/media/house_3floor.c35f31d978382e36295593208faf5db1.svg";
export { ForwardRef as ReactComponent };